export const HOME_PROJECT_FALLBACK =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjQ4MCIgdmlld0JveD0iMCAwIDMyMCA0ODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZyI+PHJlY3Qgd2lkdGg9IjMyMCIgaGVpZ2h0PSI0ODAiIGZpbGw9IiMxNDEwMTgiLz48Y2lyY2xlIGN4PSIxNjAiIGN5PSIyMDgiIHI9IjU2IiBmaWxsPSIjMzcyMjQ0Ii8+PHBhdGggZD0iTTcyIDM0NGw2OC03MiA0NiA0OCAzMi0zMiAzMCA1Nkg3MnoiIGZpbGw9IiM2ZjNhOTAiLz48L3N2Zz4=";

export const HOME_BANNER_FALLBACK =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwMCIgaGVpZ2h0PSI1MjAiIHZpZXdCb3g9IjAgMCAxMjAwIDUyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTIwMCIgaGVpZ2h0PSI1MjAiIGZpbGw9IiMxMTA5MTYiLz48cmVjdCB4PSIxMDQiIHk9Ijk2IiB3aWR0aD0iOTkyIiBoZWlnaHQ9IjMyOCIgcng9IjI0IiBmaWxsPSIjMjUxNTMzIi8+PGNpcmNsZSBjeD0iNTk4IiBjeT0iMjYwIiByPSI3MCIgZmlsbD0iIzZmM2E5MCIvPjwvc3ZnPg==";

export const HOME_AVATAR_FALLBACK =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjE2MCIgdmlld0JveD0iMCAwIDE2MCAxNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZyI+PHJlY3Qgd2lkdGg9IjE2MCIgaGVpZ2h0PSIxNjAiIHJ4PSI4MCIgZmlsbD0iIzE0MTAxOCIvPjxjaXJjbGUgY3g9IjgwIiBjeT0iNjQiIHI9IjMwIiBmaWxsPSIjNmYzYTkwIi8+PHBhdGggZD0iTTM0IDEzMGM2LTI4IDI0LTQyIDQ2LTQyczQwIDE0IDQ2IDQyIiBmaWxsPSIjMzcyMjQ0Ii8+PC9zdmc+";

export function imageWithFallback(value, fallback = HOME_PROJECT_FALLBACK) {
  return value || fallback;
}

export function setImageFallback(event, fallback = HOME_PROJECT_FALLBACK) {
  const target = event && event.target;
  if (!target || target.dataset.fallbackApplied === "true") return;
  target.dataset.fallbackApplied = "true";
  target.src = fallback;
}
